import Cookie from 'js-cookie';

import { debugLog as log } from 'shared-services/logger-service';

import store from './store';
import config from './config';
import { setTeamUrl, setAuthDetails } from './actions/auth';
import { isDev, isElectron } from 'services/env-service';
import * as localStorage from './services/local-storage-service';

const storage = isElectron() ? localStorage : Cookie;

export const setLoggingOut = () => {
    store.dispatch({ type: 'LOGGING_OUT' });
}

export const switchTeam = ({ teamUrl, keepPath, path = '/', autoCreateProject }) => {
    if (keepPath) {
        path = window.location.href.split(window.location.host)[1]
    }

    log('[SWITCH TEAM]', teamUrl, 'Keep path:', keepPath);
    setTeamUrl(teamUrl)
        .then(() => {
            if (isElectron() || isDev()) {
                if (autoCreateProject) {
                    try {
                        localStorage.set('autoShowModal', 'CREATE_PROJECT');
                    } catch(e) {

                    }
                }

                if (window.location.pathname === '/' || isElectron()) {
                    window.location.reload();
                } else {
                    window.location.pathname = '/';
                }

                return;
            }

            const href = `${window.location.protocol}//${teamUrl}.${config.APP_DOMAIN}${autoCreateProject ? '/create-project' : path}`

            log('[SWITCH TEAM] Redirect to:', href);
            window.location = href
        });
}

export const getLandingUrl = ({ path = '', keepSearch, logout }) => {
    if (logout) {
        path = '/apps?action=logout';
    }

    if (keepSearch) {
        path += window.location.search;
    };

    return `//${config.LANDING_DOMAIN}${path}`;
}

export const redirectToLanding = ({ path = '', keepSearch, logout }) => {
    if (window.inWebex) {
        return;
    }

    window.location = getLandingUrl({ path, keepSearch, logout });
};

export const logout = noRedirect => {
    const promise = setAuthDetails({
        teamUrl: null,
        masterToken: null,
        teamToken: null
    });

    if (noRedirect || isElectron() || isDev()) {
        return promise;
    }

    setLoggingOut();
    redirectToLanding({ logout: true });
};

export const getSessionLength = () => {
    return new Date() - storage.get('sessionStart');
}

export const openIntercom = () => {
    window.Intercom && window.Intercom('show');
}

export const shouldAuth = (props) => {
    return props.routes[props.routes.length - 1].noAuth;
}

export const setNotificationFavicon = () => {
    const favicons = document.querySelectorAll('head link[rel="icon"]');

    [...favicons].forEach(favicon => {
        if (favicon.href.match('notification')) {
            return;
        }

        favicon.href = favicon.href.replace('favicon', 'favicon-notification');
    });
}

export const setRegularFavicon = () => {
    const favicons = document.querySelectorAll('head link[rel="icon"]');

    Array.from(favicons).forEach(favicon => {
        favicon.href = favicon.href.replace('-notification', '');
    });
}
